import { Accordion, AccordionSet, Col, ExpandAllButton, Row } from '@folio/stripes/components';
import stripesFinalForm from '@folio/stripes/final-form';
import React, { useCallback } from 'react';
import { useField } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { FORM_ID } from '../constants';
import { AggregateSection, CriteriaSection, DataTokenSection, ExportPreviewSection, HeaderFooterSection, SchedulingSection, TransferInfoSection } from './FormSection';
function ConfigurationFormSection(_a) {
    var handleSubmit = _a.handleSubmit, formApiRef = _a.formApiRef, form = _a.form;
    formApiRef.current = form;
    var submitter = useCallback(function (e) {
        var _a;
        (_a = handleSubmit(e)) === null || _a === void 0 ? void 0 : _a.catch(function () {
            throw new Error();
        });
    }, [handleSubmit]);
    var aggregateEnabled = useField('aggregate', {
        subscription: { value: true },
        format: function (value) { return value !== null && value !== void 0 ? value : false; },
    }).input.value;
    return (React.createElement("form", { id: FORM_ID, "data-testid": FORM_ID, onSubmit: submitter },
        React.createElement(AccordionSet, null,
            React.createElement(Row, { end: "xs" },
                React.createElement(Col, { xs: true },
                    React.createElement(ExpandAllButton, null))),
            React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.scheduling.accordion" }) },
                React.createElement(SchedulingSection, null)),
            React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.criteria.accordion" }) },
                React.createElement(CriteriaSection, null)),
            React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.aggregate.accordion" }) },
                React.createElement(AggregateSection, null)),
            React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.header.accordion" }) },
                React.createElement(HeaderFooterSection, { name: "header" })),
            React.createElement(Accordion, { label: aggregateEnabled ? (React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.data.accordion.patron" })) : (React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.data.accordion.account" })) },
                React.createElement(DataTokenSection, null)),
            React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.footer.accordion" }) },
                React.createElement(HeaderFooterSection, { name: "footer" })),
            React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.preview.accordion" }) },
                React.createElement(ExportPreviewSection, null)),
            React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.transfer.accordion" }) },
                React.createElement(TransferInfoSection, null)))));
}
export default stripesFinalForm({
    validateOnBlur: false,
})(ConfigurationFormSection);
